<template>
    <input class="custom-percent-input" v-model="internalValue" :placeholder="placeholder" :id="id" @keyup="handleInput" @keydown="handleKeyDown"
        :required="required" :disabled="disabled" @blur="onBlur" :min="min" :size="size"/>
</template>

<script>
export default {
    name: 'CustomPercentageInput',
    props: {
        value: Number,
        placeholder: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        onBlur: Function,
        decimalCharacter: {
            type: String,
            default: '.'
        },
        size: {
            type: Number,
            default: 10,
        },
        min: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        internalValue() {
            if (!this.value) {
                return ''
            } else {
                if (this.decimalCharacter != '.') {
                    return `${this.value.replaceAll('.', this.decimalCharacter)}%`;
                } else {
                    return `${this.value}%`;
                }
            }
        },
    },
    methods: {
        handleKeyDown(evt) {
            const value = evt.target.value;
            const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', this.decimalCharacter, 'Backspace']
            const keyPressed = evt.key;
            if (!keysAllowed.includes(keyPressed)) {
                evt.preventDefault()
            }
            const countDecimalChar = value.split('.').length - 1;
            if (keyPressed == this.decimalCharacter && countDecimalChar == 1) {
                evt.preventDefault()
            }
            if (keyPressed == 'Backspace') {
                evt.target.value = evt.target.value.slice(0, -1)
            }
        },
        handleInput(evt) {
            const value = evt.target.value.replace('%', '');
            evt.target.value = `${value}%`;
            this.$emit('input', value.replaceAll(this.decimalCharacter, '.'));
        }
    }
}
</script>
<stype lang="scss" scoped>
.custom-percent-input {
    background-color: #fff;
    padding: 0 10px;
    font-size: 1.1em !important;
    height: 45px;
    border: 2px solid #dbdbdb;
    box-shadow: none;
    border-radius: 7px;
    text-align: center !important;

    &::placeholder {
        text-align: center;
    }
}
</stype>